let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("dsiAd"), load("co42o")]).then(() => parcelRequire('ipup0'));